var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{ref:"audioRef",staticClass:"playlist-slide-audio",style:({
    objectFit: _setup.imageMode,
    visibility: _setup.show ? 'visible' : 'hidden',
  }),attrs:{"controls":"","loop":"","texture":""}},[_c('source',{attrs:{"src":_setup.audioUrl,"type":_setup.itemType},on:{"error":_setup.handleAudioError}}),(!_setup.isWeb)?_c('source',{attrs:{"src":_setup.defaultAudioUrl,"type":_setup.itemType},on:{"error":_setup.handleDefaultAudioError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }